import { apiClient } from "@/lib/api-client";

export type MasterKonstantaItem = {
  fungsional: string;
  konstanta: number;
};

export type GetMasterKonstantaResponse = {
  datas: MasterKonstantaItem[];
  message: string;
};

export const getMasterKonstanta = async (
  year: number | string,
  semester: number | string,
): Promise<MasterKonstantaItem[]> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const resData = await apiClient<GetMasterKonstantaResponse>(
    `${baseUrl}/api/v1/master-konstanta?year=${year}&semester=${semester}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );
  return resData.datas;
};

export const putMasterKonstanta = async (
  data: MasterKonstantaItem[],
  year: number | string,
  semester: number | string
): Promise<any> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const resData = await apiClient<any>(
    `${baseUrl}/api/v1/master-konstanta?year=${year}&semester=${semester}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
  );
  return resData;
};
